/* ═══════════════════════════════════════════════════════════
   OTM CBD — PACK BUILDER

   Portage de la machine à états du prototype
   « OTM Site - standalone source.html » :
     · état     ligne 4476  → bStep, qtys, battery, skipped, club, accs
     · count()  ligne 4554
     · tierIdx()ligne 4555
     · bump()   ligne 4556
     · totaux   renderVals() ligne 4564 et suivantes
     · libellés lignes 5629–5698

   Deux écarts assumés avec la maquette, et deux seulement :

   1. Les données ne sont plus les constantes FLAVORS / BATTERIES /
      ACCESSORIES : elles sont injectées par Liquid depuis de vrais
      produits Shopify (balises <script type="application/json">).
      Les prix sont donc ceux des variants, en centimes.

   2. Le panier en mémoire (addCart, ligne 4536) est remplacé par
      window.otmCart.add(), qui poste sur /cart/add.js. Voir
      NOTE-PACK-BUILDER.md pour la décision d'architecture (option B :
      N produits distincts en un seul appel).

   Le rendu n'est pas reconstruit en JS : le markup vient de Liquid,
   ce fichier ne fait que basculer des classes, des attributs `hidden`
   et des textes. Seules les lignes du récapitulatif et les fentes du
   pack sont créées ici, parce qu'elles n'existent pas au chargement.
   ═══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* Palier ouvert : la maquette utilisait max:99 sur le dernier palier
     (source ligne 4351). On garde un plafond, simplement plus haut. */
  var OPEN_MAX = 999999;

  /* ══════════════════════════════════════════════════════════════════
     TODO-CLIENT — chevauchement à 6 non tranché.
     Alternative : 4-5 / 6-9.

     Le retour client donne « 4 à 6 » ET « 6 à 9 » : la quantité 6
     appartient littéralement aux deux paliers. Il faut choisir, sinon
     tierIdx() renvoie le premier palier qui matche et le prix dépend
     de l'ordre de déclaration — donc d'un hasard.

     Lecture implémentée : 6 reste au palier BAS  →  4-6 puis 7-9.

     UNE SEULE LIGNE À CHANGER le jour où le client répond : mettre 6
     ci-dessous. Le palier haut démarrera alors à 6 (donc 4-5 / 6-9),
     et les libellés des deux paliers concernés devront suivre dans
     templates/page.pack-builder.json.

     Le recalage ne s'applique QU'À la frontière ambiguë (6 ou 7) :
     tout autre seuil saisi dans l'éditeur est laissé intact.
     ══════════════════════════════════════════════════════════════════ */
  var OVERLAP_BOUNDARY_MIN = 7;

  /* ─────────────────────────────────────────────
     Utilitaires
     ───────────────────────────────────────────── */

  function parseJSON(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  }

  /* Le format monétaire est celui de la boutique. On délègue à otm-cart.js
     pour n'avoir qu'une seule implémentation dans le thème ; le repli ne
     sert que si ce fichier n'a pas pu être chargé. */
  function money(cents) {
    if (window.otmCart && window.otmCart.money) return window.otmCart.money(cents);
    var fmt = window.otmMoneyFormat || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100).toFixed(2);
    return fmt
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100))
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  /* Interpolation des chaînes réglables : {n}, {s}, {price}, {pct}, {pack}, {title} */
  function tpl(str, vars) {
    return String(str == null ? '' : str).replace(/\{(\w+)\}/g, function (m, key) {
      var v = vars[key];
      return v === undefined || v === null ? '' : String(v);
    });
  }

  function plural(n) {
    return n > 1 ? 's' : '';
  }

  function sumValues(obj) {
    var total = 0;
    for (var k in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, k)) total += obj[k];
    }
    return total;
  }

  function indexById(list) {
    var map = {};
    for (var i = 0; i < list.length; i++) map[String(list[i].id)] = list[i];
    return map;
  }

  function toInt(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? 0 : n;
  }

  /* ─────────────────────────────────────────────
     Constructeur
     ───────────────────────────────────────────── */

  function Builder(root) {
    this.root = root;

    this.cfg = parseJSON(root.querySelector('[data-pack-config]')) || {};
    this.flavors = parseJSON(root.querySelector('[data-pack-flavors]')) || [];
    this.batteries = parseJSON(root.querySelector('[data-pack-batteries]')) || [];
    this.accessories = parseJSON(root.querySelector('[data-pack-accessories]')) || [];
    this.plans = parseJSON(root.querySelector('[data-pack-plans]')) || [];

    this.strings = this.cfg.strings || {};
    this.tiers = this.normalizeTiers(this.cfg.tiers || []);

    this.flavorById = indexById(this.flavors);
    this.batteryById = indexById(this.batteries);
    this.accById = indexById(this.accessories);

    /* Prix de référence = le plus bas des cartouches réellement en
       catalogue. Sert d'affichage quand un palier n'a pas de prix
       unitaire réglé (le palier 1 par défaut). */
    this.referencePrice = this.flavors.reduce(function (min, f) {
      return min === null || f.price < min ? f.price : min;
    }, null);

    /* Étapes réellement rendues par Liquid : une collection vide ne
       produit pas de panneau, l'enchaînement s'adapte. */
    this.panels = Array.prototype.slice.call(root.querySelectorAll('[data-pb-step]'));
    this.rail = Array.prototype.slice.call(root.querySelectorAll('[data-pb-go]'));
    this.order = this.panels
      .map(function (p) { return toInt(p.getAttribute('data-pb-step')); })
      .sort(function (a, b) { return a - b; });

    this.el = {
      slots: root.querySelector('[data-pb-slots]'),
      lines: root.querySelector('[data-pb-lines]'),
      total: root.querySelector('[data-pb-total]'),
      cta: root.querySelector('[data-pb-cta]'),
      hint: root.querySelector('[data-pb-hint]'),
      accsHint: root.querySelector('[data-pb-accs-hint]'),
      tierTitle: root.querySelector('[data-pb-tier-title]'),
      tierPer: root.querySelector('[data-pb-tier-per]'),
      tierBar: root.querySelector('[data-pb-tier-progress]'),
      tierNext: root.querySelector('[data-pb-tier-next]'),
      ladder: root.querySelector('[data-pb-ladder]'),
      saved: root.querySelector('[data-pb-saved]'),
      giftGoal: root.querySelector('[data-pb-gift-goal]'),
      giftFill: root.querySelector('[data-pb-gift-fill]'),
      giftText: root.querySelector('[data-pb-gift-text]'),
      skipBattery: root.querySelector('[data-pb-skip-battery]'),
      freqRow: root.querySelector('[data-pb-freq-row]')
    };

    /* État — repris tel quel de la maquette (source ligne 4476).
       `freq` vient de l'état global de la maquette (ligne 4483) : il n'est
       utilisé ici que si un plan d'abonnement Shopify existe. */
    this.state = {
      bStep: this.order.length ? this.order[0] : 1,
      qtys: {},
      battery: null,
      skipped: false,
      club: null,
      accs: {},
      freq: this.plans.length ? String(this.plans[0].id) : null
    };

    this.pending = false;

    this.bind();
    this.render();
  }

  /* Un réglage vidé dans l'éditeur arrive ici à `null` (filtre `json`) :
     on ne veut pas écrire « null » dans la page. */
  /* Valeurs de repli des chaînes introduites le 10/09/2026.

     Elles NE PEUVENT PAS vivre dans un filtre `default:` Liquid : elles
     contiennent des accolades ({pct}, {amount}), et une accolade dans une
     chaîne à l'intérieur d'un {{ }} casse l'analyse — « Liquid syntax
     error : Variable was not properly terminated », section entière
     refusée à l'envoi, page en 500. Mesuré le 10/09/2026.

     Elles servent tant que le gabarit ne porte pas encore le réglage :
     un réglage neuf vaut nil jusqu'à ce que quelqu'un l'enregistre. */
  var REPLIS = {
    save_pct: '−{pct} %',
    saved_line: '{amount} économisés sur ce pack.',
    gift_goal: 'Encore {amount} et la sacoche est offerte.',
    gift_reached: 'Sacoche offerte ✓'
  };

  Builder.prototype.str = function (key) {
    var v = this.strings[key];
    if (v === undefined || v === null || v === '') {
      return Object.prototype.hasOwnProperty.call(REPLIS, key) ? REPLIS[key] : '';
    }
    return v;
  };

  /* Les paliers arrivent triés par quantité minimale. Le maximum d'un
     palier est déduit du minimum du suivant — la maquette le codait en
     dur (1/1, 2/3, 4/5, 6/9, 10/99). */
  Builder.prototype.normalizeTiers = function (raw) {
    /* Tant que les remises automatiques ne sont pas créées en boutique, le
       prix de palier est une PROMESSE QUE LE PANIER NE TIENDRA PAS : mesuré
       en runtime le 19/08/2026, 6 cartouches affichaient 107,94 € pour
       119,94 € réellement facturés. On neutralise donc unit_price, et
       unitPrice() retombe sur le prix réel du variant. Écart ramené à 0,00 €.
       Le réglage discounts_live rétablit l'affichage dégressif une fois les
       remises créées. */
    if (!this.cfg.discounts_live) {
      raw = raw.map(function (t) {
        return { min: t.min, label: t.label, unit_price: null };
      });
    }
    /* Recalage de la frontière ambiguë — voir OVERLAP_BOUNDARY_MIN. */
    var tiers = raw.map(function (t) {
      if (t.min === 6 || t.min === 7) {
        return {
          min: OVERLAP_BOUNDARY_MIN,
          label: t.label,
          unit_price: t.unit_price
        };
      }
      return t;
    });
    tiers = tiers.sort(function (a, b) { return a.min - b.min; });
    return tiers.map(function (t, i) {
      var next = tiers[i + 1];
      return {
        min: t.min,
        max: next ? next.min - 1 : OPEN_MAX,
        label: t.label || '',
        unit_price: t.unit_price === undefined ? null : t.unit_price
      };
    });
  };

  /* ─────────────────────────────────────────────
     Logique de la maquette, reportée à l'identique
     ───────────────────────────────────────────── */

  /* source ligne 4554 */
  Builder.prototype.count = function () {
    return sumValues(this.state.qtys);
  };

  /* source ligne 4555 */
  Builder.prototype.tierIdx = function () {
    var n = this.count() || 1;
    for (var i = 0; i < this.tiers.length; i++) {
      if (n >= this.tiers[i].min && n <= this.tiers[i].max) return i;
    }
    return 0;
  };

  /* source ligne 4556 */
  Builder.prototype.bump = function (id, d) {
    var q = this.state.qtys;
    var key = String(id);
    q[key] = Math.max(0, (q[key] || 0) + d);
    if (!q[key]) delete q[key];
    /* Mémorise la dernière saveur touchée : c'est elle que goToTier()
       complète quand le client saute à un palier supérieur. */
    else if (d > 0) this.state.lastPicked = key;
    this.render();
  };

  Builder.prototype.bumpAcc = function (id, d) {
    var a = this.state.accs;
    var key = String(id);
    a[key] = Math.max(0, (a[key] || 0) + d);
    if (!a[key]) delete a[key];
    this.render();
  };

  /* Prix unitaire d'une cartouche au palier courant.
     Palier sans prix réglé → prix réel du variant Shopify. */
  Builder.prototype.unitPrice = function (flavor, tier) {
    if (tier && tier.unit_price !== null && tier.unit_price !== undefined) {
      return tier.unit_price;
    }
    return flavor ? flavor.price : 0;
  };

  /* Ordre de calcul identique à renderVals() (source ligne 4564) :
     cartouches au prix du palier, puis batterie, puis accessoires,
     puis remise abonnement appliquée sur le total. */
  Builder.prototype.compute = function () {
    var st = this.state;
    var self = this;
    var n = this.count();
    var ti = this.tierIdx();
    var tier = this.tiers[ti] || { min: 1, max: OPEN_MAX, label: '', unit_price: null };
    var nextTier = this.tiers[ti + 1] || null;
    var lines = [];
    var total = 0;
    /* Économie réalisée sur les cartouches, en centimes : pour chaque
       saveur, l'écart entre son prix de variant et le prix du palier.
       Calculé, jamais saisi. Vaut 0 quand discounts_live est décoché,
       puisque unitPrice() retombe alors sur le prix du variant. */
    var saved = 0;

    this.flavors.forEach(function (f) {
      var q = st.qtys[String(f.id)] || 0;
      if (!q) return;
      var per = self.unitPrice(f, tier);
      saved += q * Math.max(0, (f.price || 0) - per);
      lines.push({
        name: f.title,
        image: f.image,
        sub: q + ' × ' + money(per),
        price: q * per
      });
      total += q * per;
    });

    if (st.battery) {
      var b = this.batteryById[String(st.battery)];
      if (b) {
        lines.push({
          name: b.title,
          image: b.image,
          sub: this.str('battery_line'),
          price: b.price
        });
        total += b.price;
      }
    }

    var accsCount = 0;
    this.accessories.forEach(function (a) {
      var qa = st.accs[String(a.id)] || 0;
      if (!qa) return;
      accsCount += qa;
      lines.push({
        name: a.title,
        image: a.image,
        sub: qa + ' × ' + money(a.price),
        price: qa * a.price
      });
      total += qa * a.price;
    });

    /* source ligne 4584 : if (st.club === 'sub') bTotal *= 0.85 */
    var clubPct = toInt(this.cfg.club_discount);
    if (st.club === 'sub' && clubPct > 0) {
      total = Math.round(total * (1 - clubPct / 100));
    }

    return {
      n: n,
      ti: ti,
      tier: tier,
      nextTier: nextTier,
      lines: lines,
      total: total,
      saved: saved,
      accsCount: accsCount
    };
  };

  /* ─────────────────────────────────────────────
     Navigation entre étapes
     ───────────────────────────────────────────── */

  Builder.prototype.go = function (step) {
    if (this.order.indexOf(step) === -1) return;
    this.state.bStep = step;
    this.render();
  };

  Builder.prototype.isLastStep = function () {
    return this.state.bStep === this.order[this.order.length - 1];
  };

  Builder.prototype.nextStep = function () {
    var i = this.order.indexOf(this.state.bStep);
    return i >= 0 && i < this.order.length - 1 ? this.order[i + 1] : null;
  };

  /* source ligne 5693 : builderNext.
     Un seul durcissement : la maquette ne bloquait le bouton qu'à l'étape 1
     (« if (st.bStep===1 && n===0) return »), ce qui permettait, en sautant
     par le rail, d'ajouter au panier un pack de zéro cartouche. Le garde
     porte ici sur toutes les étapes. */
  Builder.prototype.advance = function () {
    if (this.count() === 0) return;
    var next = this.nextStep();
    if (next !== null) {
      this.go(next);
      return;
    }
    this.addToCart();
  };

  /* ─────────────────────────────────────────────
     Ajout au panier — option B (voir NOTE-PACK-BUILDER.md)
     ───────────────────────────────────────────── */

  Builder.prototype.sellingPlanId = function () {
    if (this.state.club !== 'sub' || !this.plans.length) return null;
    var wanted = this.state.freq;
    for (var i = 0; i < this.plans.length; i++) {
      if (String(this.plans[i].id) === String(wanted)) return this.plans[i].id;
    }
    return this.plans[0].id;
  };

  Builder.prototype.addToCart = function () {
    var st = this.state;
    var self = this;
    var c = this.compute();

    if (!c.n || this.pending) return;
    if (!window.otmCart || !window.otmCart.add) return;

    var packName = tpl(this.str('pack_name'), { n: c.n, s: plural(c.n) });
    /* Référence commune à toutes les lignes d'un même pack : elle empêche
       Shopify de fusionner deux packs distincts et rend la commande
       lisible en préparation. Préfixée « _ » donc masquée au client. */
    var packRef = 'otm-' + Date.now().toString(36);
    var packKey = this.cfg.pack_property || 'Pack';
    var tierKey = this.cfg.tier_property || 'Palier';
    var plan = this.sellingPlanId();
    var items = [];

    function baseProps() {
      var p = {};
      if (packKey) p[packKey] = packName;
      p._otm_pack = packRef;
      return p;
    }

    this.flavors.forEach(function (f) {
      var q = st.qtys[String(f.id)] || 0;
      if (!q) return;
      var props = baseProps();
      if (tierKey && c.tier.label) props[tierKey] = c.tier.label;
      var item = { id: f.id, quantity: q, properties: props };
      if (plan && f.plans && f.plans.indexOf(plan) !== -1) item.selling_plan = plan;
      items.push(item);
    });

    if (st.battery) {
      var b = this.batteryById[String(st.battery)];
      if (b) items.push({ id: b.id, quantity: 1, properties: baseProps() });
    }

    this.accessories.forEach(function (a) {
      var qa = st.accs[String(a.id)] || 0;
      if (!qa) return;
      items.push({ id: a.id, quantity: qa, properties: baseProps() });
    });

    if (!items.length) return;

    this.pending = true;
    if (this.el.cta) this.el.cta.setAttribute('aria-busy', 'true');

    window.otmCart
      /* Idem fiche produit : l'annulation est atomique, le message doit le
         dire. Sans lui, l'utilisateur lit une erreur de stock sur UNE
         saveur alors que tout le pack a été retiré. */
      .add(items, {
        message: tpl(this.str('add_message'), { pack: packName }),
        rollbackMessage: this.str('rollback_message') || ''
      })
      .catch(function () { /* otm-cart.js a déjà affiché le message d'erreur */ })
      .then(function () {
        self.pending = false;
        if (self.el.cta) self.el.cta.removeAttribute('aria-busy');
        self.render();
      });
  };

  /* ─────────────────────────────────────────────
     Rendu
     ───────────────────────────────────────────── */

  Builder.prototype.render = function () {
    var st = this.state;
    var self = this;
    var c = this.compute();

    /* Rail d'étapes — source ligne 5629 */
    this.rail.forEach(function (btn) {
      var s = toInt(btn.getAttribute('data-pb-go'));
      btn.classList.toggle('is-done', st.bStep >= s);
      if (st.bStep === s) btn.setAttribute('aria-current', 'step');
      else btn.removeAttribute('aria-current');
    });

    this.panels.forEach(function (panel) {
      panel.hidden = toInt(panel.getAttribute('data-pb-step')) !== st.bStep;
    });

    /* Cartes saveur — source ligne 5652 */
    this.flavors.forEach(function (f) {
      var card = self.root.querySelector('[data-pb-card="' + f.id + '"]');
      if (!card) return;
      var q = st.qtys[String(f.id)] || 0;
      card.classList.toggle('is-on', q > 0);

      var badge = card.querySelector('[data-pb-badge]');
      if (badge) badge.hidden = q === 0;
      var qty = card.querySelector('[data-pb-qty]');
      if (qty) qty.textContent = q;
      var label = card.querySelector('[data-pb-addlabel]');
      if (label) label.textContent = q ? self.str('add_more') : self.str('add');
      var minus = card.querySelector('[data-pb-sub]');
      if (minus) minus.disabled = q === 0;
    });

    /* Batteries — source ligne 5662 */
    this.batteries.forEach(function (b) {
      var card = self.root.querySelector('[data-pb-battery-card="' + b.id + '"]');
      if (!card) return;
      var on = String(st.battery) === String(b.id);
      card.classList.toggle('is-on', on);
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
      var check = card.querySelector('[data-pb-check]');
      if (check) check.hidden = !on;
    });
    if (this.el.skipBattery) {
      this.el.skipBattery.classList.toggle('is-on', st.skipped);
      this.el.skipBattery.setAttribute('aria-pressed', st.skipped ? 'true' : 'false');
    }

    /* Accessoires — source ligne 5636 */
    this.accessories.forEach(function (a) {
      var card = self.root.querySelector('[data-pb-acc-card="' + a.id + '"]');
      if (!card) return;
      var qa = st.accs[String(a.id)] || 0;
      card.classList.toggle('is-on', qa > 0);
      var badge = card.querySelector('[data-pb-badge]');
      if (badge) badge.hidden = qa === 0;
      var qty = card.querySelector('[data-pb-qty]');
      if (qty) qty.textContent = qa;
      var label = card.querySelector('[data-pb-addlabel]');
      if (label) label.textContent = qa ? self.str('add_more') : self.str('add');
      var minus = card.querySelector('[data-pb-acc-sub]');
      if (minus) minus.disabled = qa === 0;
    });

    /* Club — source ligne 5673 */
    ['sub', 'once'].forEach(function (kind) {
      var card = self.root.querySelector('[data-pb-club="' + kind + '"]');
      if (!card) return;
      var on = st.club === kind;
      card.classList.toggle('is-on', on);
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (this.el.freqRow) this.el.freqRow.hidden = st.club !== 'sub';
    this.root.querySelectorAll('[data-pb-freq]').forEach(function (chip) {
      var on = String(st.freq) === chip.getAttribute('data-pb-freq');
      chip.classList.toggle('otm-chip--on', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    /* Intitulés dynamiques — source lignes 5647 et 5650 */
    if (this.el.hint) {
      this.el.hint.textContent = c.n === 0
        ? this.str('hint_empty')
        : tpl(this.str('hint_count'), {
            n: c.n,
            s: plural(c.n),
            price: money(this.unitPrice(null, c.tier) || this.referencePrice || 0)
          });
    }
    if (this.el.accsHint) {
      this.el.accsHint.textContent = c.accsCount === 0
        ? this.str('accs_hint_empty')
        : tpl(this.str('accs_hint_count'), { n: c.accsCount, s: plural(c.accsCount) });
    }

    /* Palier — source lignes 5676–5685 */
    if (this.root && !this.cfg.discounts_live) this.root.classList.add('pb--no-tiers');
    this.renderSlots(c.n);
    if (this.el.tierTitle) this.el.tierTitle.textContent = c.tier.label;
    if (this.el.tierPer) {
      var per = c.tier.unit_price !== null && c.tier.unit_price !== undefined
        ? c.tier.unit_price
        : (this.referencePrice || 0);
      this.el.tierPer.textContent = (money(per) + ' ' + this.str('per_unit')).trim();
    }
    if (this.el.tierBar) {
      var pct = this.tiers.length
        ? Math.min(100, Math.round(((c.ti + (c.n ? 1 : 0)) / this.tiers.length) * 100))
        : 0;
      this.el.tierBar.style.width = pct + '%';
    }
    if (this.el.tierNext) {
      /* Sans remises reelles, le palier suivant ne promet rien : on n'ecrit
         rien plutot que d'inventer une formule de remplacement. La regle CSS
         .pb--no-tiers masque la ligne, le texte est vide par securite. */
      if (!this.cfg.discounts_live) {
        this.el.tierNext.textContent = '';
      } else if (c.nextTier) {
        var left = c.nextTier.min - c.n;
        this.el.tierNext.textContent = tpl(this.str('tier_next'), {
          n: left,
          s: plural(left),
          price: money(this.unitPrice(null, c.nextTier) || this.referencePrice || 0)
        });
      } else {
        this.el.tierNext.textContent = tpl(this.str('tier_best'), { pct: this.bestPct() });
      }
    }

    this.renderLadder(c);
    this.renderSaved(c);
    this.renderGiftGoal(c);

    this.renderLines(c.lines);
    if (this.el.total) this.el.total.textContent = money(c.total);

    /* Bouton principal — source lignes 5688–5692 */
    if (this.el.cta) {
      var disabled = c.n === 0;
      /* cta_N nomme l'etape SUIVANTE (« Continuer vers les accessoires »).
         Quand une etape est absente du parcours — pas de collection
         d'accessoires, par exemple — le libelle designerait une etape
         qui n'existe pas. On retombe alors sur cta_3, neutre. */
      var nxt = this.nextStep();
      var key = disabled && this.state.bStep === this.order[0]
        ? 'cta_empty'
        : this.isLastStep()
          ? 'cta_final'
          : (nxt === this.state.bStep + 1 ? 'cta_' + this.state.bStep : 'cta_3');
      this.el.cta.textContent = this.str(key) || this.str('cta_final');
      this.el.cta.disabled = disabled;
      this.el.cta.setAttribute('aria-disabled', disabled ? 'true' : 'false');
    }
  };

  /* ─────────────────────────────────────────────
     ÉCHELLE DES PALIERS

     La maquette montre les paliers TOUS ENSEMBLE (otm-pack-builder.html,
     ligne 629) : quantité, prix unitaire, « Économise X % ». C'est là
     qu'est l'intention commerciale — le client voit l'escalier, pas
     seulement la marche où il se trouve. L'implémentation n'affichait que
     la marche courante.

     Trois états par barreau, et ils disent trois choses différentes :
       is-done    déjà atteint — ce que tu as
       is-current la marche courante — ce que tu paies
       is-next    la suivante — ce que tu gagnerais
     ───────────────────────────────────────────── */
  Builder.prototype.renderLadder = function (c) {
    var box = this.el.ladder;
    if (!box) return;
    var base = this.referencePrice || 0;
    var self = this;
    var rungs = box.querySelectorAll('[data-pb-rung]');
    Array.prototype.forEach.call(rungs, function (li, i) {
      var t = self.tiers[i];
      if (!t) return;
      var per = (t.unit_price !== null && t.unit_price !== undefined) ? t.unit_price : base;

      var perEl = li.querySelector('[data-pb-rung-per]');
      if (perEl) perEl.textContent = (money(per) + ' ' + self.str('per_unit')).trim();

      /* Le pourcentage se calcule contre le prix réel du variant. Sans prix
         de référence, on n'écrit rien plutôt qu'un « −0 % » faux. */
      var saveEl = li.querySelector('[data-pb-rung-save]');
      if (saveEl) {
        var pct = base > 0 ? Math.round((1 - per / base) * 100) : 0;
        saveEl.textContent = pct > 0 ? tpl(self.str('save_pct'), { pct: pct }) : '';
      }

      var atteint = c.n > 0 && c.n >= t.min;
      var courant = c.n > 0 && i === c.ti;
      var suivant = c.nextTier && t.min === c.nextTier.min;
      li.classList.toggle('is-done', atteint && !courant);
      li.classList.toggle('is-current', courant);
      li.classList.toggle('is-next', !!suivant);

      /* Le bouton complète le pack jusqu'à ce palier. Pack vide, il est
         inerte : compléter supposerait de choisir une saveur à la place
         du client. Palier déjà atteint, il n'a rien à faire. */
      var btn = li.querySelector('[data-pb-rung-go]');
      if (btn) {
        var actif = c.n > 0 && t.min > c.n;
        btn.disabled = !actif;
        btn.setAttribute('aria-disabled', actif ? 'false' : 'true');
        btn.setAttribute('aria-current', courant ? 'true' : 'false');
      }
    });
  };

  /* Monte le pack au minimum du palier visé. Le complément part sur la
     DERNIÈRE saveur choisie : déterministe, visible dans le récapitulatif,
     et annulable d'un « − ». */
  Builder.prototype.goToTier = function (min) {
    var n = this.count();
    if (!n || min <= n) return;
    var manque = min - n;
    var key = this.state.lastPicked;
    if (!key || !this.state.qtys[key]) {
      var cles = Object.keys(this.state.qtys);
      key = cles[cles.length - 1];
    }
    if (!key) return;
    this.state.qtys[key] = (this.state.qtys[key] || 0) + manque;
    this.render();
  };

  /* « 12,00 € économisés sur ce pack. » Un montant se lit plus vite qu'un
     pourcentage. Rien à afficher tant qu'il n'y a pas d'économie — et il
     n'y en a aucune quand discounts_live est décoché. */
  Builder.prototype.renderSaved = function (c) {
    var el = this.el.saved;
    if (!el) return;
    var texte = this.str('saved_line');
    if (!texte || !c.saved || c.saved <= 0) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.textContent = tpl(texte, { amount: money(c.saved) });
  };

  /* Progression vers la sacoche offerte. Le seuil vient du réglage, en
     centimes. À 0, rien n'est rendu : l'écran ne promet pas une gratuité
     dont la remise Shopify n'est pas vérifiée. */
  Builder.prototype.renderGiftGoal = function (c) {
    var box = this.el.giftGoal;
    if (!box) return;
    var seuil = toInt(this.cfg.gift_threshold);
    if (!seuil || c.total <= 0) { box.hidden = true; return; }
    box.hidden = false;
    var atteint = c.total >= seuil;
    var pct = Math.min(100, Math.round((c.total / seuil) * 100));
    if (this.el.giftFill) this.el.giftFill.style.width = pct + '%';
    box.classList.toggle('is-reached', atteint);
    if (this.el.giftText) {
      this.el.giftText.textContent = atteint
        ? this.str('gift_reached')
        : tpl(this.str('gift_goal'), { amount: money(seuil - c.total) });
    }
  };

  /* « Meilleur palier atteint : −30 % » — le pourcentage n'est pas écrit
     dans la maquette, il s'y déduit de 13,90 / 19,99. On le recalcule ici
     depuis les paliers réglés plutôt que de le figer. */
  Builder.prototype.bestPct = function () {
    var first = this.tiers.length ? this.tiers[0] : null;
    var last = this.tiers.length ? this.tiers[this.tiers.length - 1] : null;
    if (!first || !last) return 0;
    var base = first.unit_price !== null && first.unit_price !== undefined
      ? first.unit_price
      : this.referencePrice;
    var low = last.unit_price !== null && last.unit_price !== undefined
      ? last.unit_price
      : this.referencePrice;
    if (!base || !low) return 0;
    return Math.round((1 - low / base) * 100);
  };

  /* source ligne 5676 : Math.max(6, n) fentes, remplies jusqu'à n */
  Builder.prototype.renderSlots = function (n) {
    var box = this.el.slots;
    if (!box) return;
    var want = Math.max(6, n);
    while (box.children.length > want) box.removeChild(box.lastChild);
    while (box.children.length < want) {
      var slot = document.createElement('span');
      slot.className = 'pb-slot';
      box.appendChild(slot);
    }
    for (var i = 0; i < box.children.length; i++) {
      box.children[i].classList.toggle('is-on', i < n);
    }
  };

  /* source ligne 5686 : builderLines */
  Builder.prototype.renderLines = function (lines) {
    var box = this.el.lines;
    if (!box) return;
    box.textContent = '';
    lines.forEach(function (l) {
      var row = document.createElement('li');
      row.className = 'pb-line';

      var thumb = document.createElement('span');
      thumb.className = 'pb-line__thumb';
      if (l.image) {
        var img = document.createElement('img');
        img.src = l.image;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      }

      var body = document.createElement('span');
      body.className = 'pb-line__body';
      var name = document.createElement('span');
      name.className = 'pb-line__name';
      name.textContent = l.name;
      var sub = document.createElement('span');
      sub.className = 'pb-line__sub';
      sub.textContent = l.sub;
      body.appendChild(name);
      body.appendChild(sub);

      var price = document.createElement('span');
      price.className = 'pb-line__price otm-num';
      price.textContent = money(l.price);

      row.appendChild(thumb);
      row.appendChild(body);
      row.appendChild(price);
      box.appendChild(row);
    });
  };

  /* ─────────────────────────────────────────────
     Évènements — délégation unique sur la racine.
     Tous les contrôles sont de vrais <button> : la navigation clavier
     et l'activation Entrée/Espace sont natives.
     ───────────────────────────────────────────── */

  Builder.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      var t;

      if ((t = e.target.closest('[data-pb-go]'))) {
        self.go(toInt(t.getAttribute('data-pb-go')));
        return;
      }
      if ((t = e.target.closest('[data-pb-sub]'))) {
        self.bump(t.getAttribute('data-pb-sub'), -1);
        return;
      }
      if ((t = e.target.closest('[data-pb-add]'))) {
        self.bump(t.getAttribute('data-pb-add'), 1);
        return;
      }
      if ((t = e.target.closest('[data-pb-rung-go]'))) {
        self.goToTier(toInt(t.getAttribute('data-pb-rung-go')));
        return;
      }
      if ((t = e.target.closest('[data-pb-battery-card]'))) {
        /* source ligne 5667 */
        self.state.battery = t.getAttribute('data-pb-battery-card');
        self.state.skipped = false;
        self.render();
        return;
      }
      if (e.target.closest('[data-pb-skip-battery]')) {
        /* source ligne 5669 */
        self.state.battery = null;
        self.state.skipped = true;
        self.render();
        return;
      }
      if ((t = e.target.closest('[data-pb-acc-sub]'))) {
        self.bumpAcc(t.getAttribute('data-pb-acc-sub'), -1);
        return;
      }
      if ((t = e.target.closest('[data-pb-acc-add]'))) {
        self.bumpAcc(t.getAttribute('data-pb-acc-add'), 1);
        return;
      }
      if (e.target.closest('[data-pb-skip-accs]')) {
        /* source ligne 5649 : vide les accessoires et passe à l'étape suivante */
        self.state.accs = {};
        var next = self.nextStep();
        if (next !== null) self.state.bStep = next;
        self.render();
        return;
      }
      if ((t = e.target.closest('[data-pb-club]'))) {
        self.state.club = t.getAttribute('data-pb-club');
        self.render();
        return;
      }
      if ((t = e.target.closest('[data-pb-freq]'))) {
        self.state.freq = t.getAttribute('data-pb-freq');
        self.render();
        return;
      }
      if (e.target.closest('[data-pb-cta]')) {
        self.advance();
      }
    });
  };

  /* ─────────────────────────────────────────────
     Amorçage
     ───────────────────────────────────────────── */

  function init() {
    document.querySelectorAll('[data-pack-builder]').forEach(function (root) {
      if (root.dataset.pbInit) return;
      root.dataset.pbInit = '1';
      new Builder(root);
    });
  }

  /* Amorçage sur `load`, pas sur DOMContentLoaded : ce fichier est chargé
     par la section, donc dans <main>, alors qu'otm-cart.js l'est en fin de
     <body>. Les deux sont `defer` et s'exécutent dans l'ordre du document —
     attendre `load` garantit que window.otmCart existe au premier rendu.
     Le markup rendu par Liquid est déjà dans son état initial correct
     (pastilles masquées, boutons « − » et bouton principal désactivés). */
  /* Attendre `load` laissait onze contrôles inertes tant que toutes les
     images de la page n'étaient pas descendues. On amorce dès que le DOM
     est prêt SI window.otmCart est déjà là ; sinon seulement on attend. */
  function boot() {
    if (window.otmCart) { init(); return true; }
    return false;
  }
  if (document.readyState === 'complete') {
    init();
  } else if (document.readyState !== 'loading' && boot()) {
    /* amorcé */
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (!boot()) window.addEventListener('load', init);
    });
    window.addEventListener('load', init);
  }

  /* Ré-amorçage après un rendu de l'éditeur de thème. */
  document.addEventListener('shopify:section:load', init);
})();
